var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptRefundOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 10V9.33333C10.6667 8.62609 10.3858 7.94781 9.8857 7.44772C9.3856 6.94762 8.70733 6.66667 8.00008 6.66667H5.33341M5.33341 6.66667L7.33341 8.66667M5.33341 6.66667L7.33341 4.66667M13.3334 14V3.33333C13.3334 2.97971 13.1929 2.64057 12.9429 2.39052C12.6928 2.14048 12.3537 2 12.0001 2H4.00008C3.64646 2 3.30732 2.14048 3.05727 2.39052C2.80722 2.64057 2.66675 2.97971 2.66675 3.33333V14L5.33341 12.6667L8.00008 14L10.6667 12.6667L13.3334 14Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptRefundOutline);
export default __webpack_public_path__ + "static/media/ReceiptRefundOutline.6f5542a0265ae69a6c670e8a2c414cbe.svg";
export { ForwardRef as ReactComponent };